import { FaAward, FaPlus, FaUser } from "react-icons/fa";
import { useState } from "react";

export default function Nominations() {
  const [positions, setPositions] = useState([
    {
      id: 1,
      title: "Chair",
      description: "Lead the Staff Council, represent members in organizational decisions, and oversee all council activities",
      term: "2025-2026",
      deadline: "2025-02-15",
      status: "open",
      nominations: [
        { id: 1, name: "Sarah Johnson", nominatedBy: "Anonymous", statement: "Extensive leadership experience and passion for staff advocacy" },
        { id: 2, name: "Michael Chen", nominatedBy: "Anonymous", statement: "Strong communication skills and proven track record" },
      ],
    },
    {
      id: 2,
      title: "Vice Chair",
      description: "Support the Chair, coordinate council activities, and lead in the Chair's absence",
      term: "2025-2026",
      deadline: "2025-02-15",
      status: "open",
      nominations: [
        { id: 3, name: "Emily Rodriguez", nominatedBy: "Anonymous", statement: "Organized, reliable, and dedicated to staff interests" },
      ],
    },
    {
      id: 3,
      title: "Academic Staff Committee Chair",
      description: "Lead the Academic Staff committee, represent academic staff interests, and coordinate academic initiatives",
      term: "2025-2026",
      deadline: "2025-02-15",
      status: "open",
      nominations: [],
    },
    {
      id: 4,
      title: "Researcher Committee Chair",
      description: "Lead the Researchers committee, advocate for researcher interests, and coordinate research-related initiatives",
      term: "2025-2026",
      deadline: "2025-02-15",
      status: "open",
      nominations: [],
    },
    {
      id: 5,
      title: "Communications Officer",
      description: "Manage council communications, maintain social media presence, and coordinate outreach activities",
      term: "2025-2026",
      deadline: "2025-02-15",
      status: "open",
      nominations: [
        { id: 5, name: "Lisa Martinez", nominatedBy: "Anonymous", statement: "Strong writing skills and experience in communications" },
      ],
    },
    {
      id: 6,
      title: "Governance Liaison Officer",
      description: "Coordinate with university governance bodies, maintain council bylaws, and ensure procedural compliance",
      term: "2025-2026",
      deadline: "2025-02-15",
      status: "open",
      nominations: [],
    },
    {
      id: 7,
      title: "HR Officer",
      description: "Address staff HR concerns, liaise with HR department, and advocate for staff welfare policies",
      term: "2025-2026",
      deadline: "2025-02-15",
      status: "open",
      nominations: [],
    },
    {
      id: 8,
      title: "Belonging Officer",
      description: "Foster inclusive environment, coordinate belonging initiatives, and support diversity efforts",
      term: "2025-2026",
      deadline: "2025-02-15",
      status: "open",
      nominations: [
        { id: 6, name: "Ahmed Hassan", nominatedBy: "Anonymous", statement: "Passionate about inclusivity and community building" },
      ],
    },
    {
      id: 9,
      title: "Chair",
      description: "Lead the Staff Council and represent members in organizational decisions",
      term: "2024-2025",
      deadline: "2024-12-15",
      status: "closed",
      nominations: [
        { id: 7, name: "Josie Simm", nominatedBy: "Anonymous", statement: "Outstanding leadership and commitment to staff advocacy" },
      ],
    },
  ]);

  const [showNominationForm, setShowNominationForm] = useState(null);
  const [nomineeForm, setNomineeForm] = useState({ name: "", statement: "" });

  const submitNomination = (positionId) => {
    if (!nomineeForm.name || !nomineeForm.statement) {
      alert("Please fill in all fields");
      return;
    }

    setPositions(
      positions.map((pos) =>
        pos.id === positionId
          ? {
              ...pos,
              nominations: [
                ...pos.nominations,
                {
                  id: Date.now(),
                  name: nomineeForm.name,
                  nominatedBy: "Anonymous",
                  statement: nomineeForm.statement,
                },
              ],
            }
          : pos
      )
    );

    setNomineeForm({ name: "", statement: "" });
    setShowNominationForm(null);
    alert("Nomination submitted successfully!");
  };

  const openPositions = positions.filter((p) => p.status === "open");
  const closedPositions = positions.filter((p) => p.status === "closed");

  const PositionCard = ({ position }) => (
    <div
      style={{
        background: "white",
        borderRadius: "12px",
        padding: "24px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
        border: "1px solid #e2e8f0",
        marginBottom: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
          marginBottom: "16px",
        }}
      >
        <div>
          <h3
            style={{
              fontSize: "22px",
              fontWeight: "600",
              color: "#2d3748",
              margin: "0 0 8px 0",
            }}
          >
            {position.title}
          </h3>
          <p
            style={{
              color: "#4a5568",
              fontSize: "15px",
              marginBottom: "12px",
            }}
          >
            {position.description}
          </p>
        </div>
        <span
          style={{
            padding: "6px 14px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: "600",
            background: position.status === "open" ? "#e6f7ee" : "#f0f0f0",
            color: position.status === "open" ? "#38a169" : "#718096",
          }}
        >
          {position.status.toUpperCase()}
        </span>
      </div>

      <div
        style={{
          display: "flex",
          gap: "20px",
          fontSize: "13px",
          color: "#718096",
          marginBottom: "20px",
          paddingBottom: "20px",
          borderBottom: "1px solid #e2e8f0",
        }}
      >
        <div>
          <strong>Term:</strong> {position.term}
        </div>
        <div>
          <strong>Deadline:</strong> {new Date(position.deadline).toLocaleDateString()}
        </div>
        <div>
          <strong>Nominations:</strong> {position.nominations.length}
        </div>
      </div>

      {/* Nominations List */}
      <div style={{ marginBottom: "16px" }}>
        <h4
          style={{
            fontSize: "16px",
            fontWeight: "600",
            color: "#2d3748",
            marginBottom: "12px",
          }}
        >
          Nominees
        </h4>
        {position.nominations.length > 0 ? (
          position.nominations.map((nomination) => (
            <div
              key={nomination.id}
              style={{
                padding: "16px",
                background: "#f7fafc",
                borderRadius: "8px",
                marginBottom: "10px",
                border: "1px solid #e2e8f0",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "8px",
                }}
              >
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "#667eea",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                  }}
                >
                  <FaUser />
                </div>
                <div>
                  <div
                    style={{
                      fontWeight: "600",
                      color: "#2d3748",
                      fontSize: "15px",
                    }}
                  >
                    {nomination.name}
                  </div>
                  <div style={{ fontSize: "12px", color: "#718096" }}>
                    Nominated by {nomination.nominatedBy}
                  </div>
                </div>
              </div>
              <p
                style={{
                  fontSize: "14px",
                  color: "#4a5568",
                  lineHeight: "1.5",
                  margin: 0,
                  paddingLeft: "50px",
                }}
              >
                {nomination.statement}
              </p>
            </div>
          ))
        ) : (
          <p style={{ color: "#718096", fontStyle: "italic", fontSize: "14px" }}>
            No nominations yet
          </p>
        )}
      </div>

      {/* Nomination Form */}
      {position.status === "open" && (
        <>
          {showNominationForm === position.id ? (
            <div
              style={{
                padding: "16px",
                background: "#f7fafc",
                borderRadius: "8px",
                border: "2px solid #667eea",
              }}
            >
              <h4 style={{ fontSize: "14px", fontWeight: "600", marginBottom: "12px" }}>
                Submit Nomination
              </h4>
              <input
                type="text"
                placeholder="Nominee Name"
                value={nomineeForm.name}
                onChange={(e) => setNomineeForm({ ...nomineeForm, name: e.target.value })}
                style={{
                  width: "100%",
                  padding: "10px",
                  marginBottom: "10px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "6px",
                  fontSize: "14px",
                }}
              />
              <textarea
                placeholder="Why is this person a good fit for the position?"
                value={nomineeForm.statement}
                onChange={(e) => setNomineeForm({ ...nomineeForm, statement: e.target.value })}
                style={{
                  width: "100%",
                  padding: "10px",
                  marginBottom: "10px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "6px",
                  fontSize: "14px",
                  minHeight: "80px",
                  resize: "vertical",
                }}
              />
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  onClick={() => submitNomination(position.id)}
                  style={{
                    padding: "8px 16px",
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  Submit
                </button>
                <button
                  onClick={() => {
                    setShowNominationForm(null);
                    setNomineeForm({ name: "", statement: "" });
                  }}
                  style={{
                    padding: "8px 16px",
                    background: "#e2e8f0",
                    color: "#4a5568",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            <button
              onClick={() => setShowNominationForm(position.id)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "10px 16px",
                background: "#667eea",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              <FaPlus />
              Nominate Someone
            </button>
          )}
        </>
      )}
    </div>
  );

  return (
    <div
      style={{
        padding: "40px",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      {/* Header */}
      <div style={{ marginBottom: "40px" }}>
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "700",
            color: "#2d3748",
            marginBottom: "8px",
          }}
        >
          Officer Nominations
        </h1>
        <p style={{ color: "#718096", fontSize: "16px" }}>
          Nominate qualified members for council officer positions
        </p>
      </div>

      {/* Open Positions */}
      <div style={{ marginBottom: "40px" }}>
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            color: "#2d3748",
            marginBottom: "20px",
          }}
        >
          Open for Nominations
        </h2>
        {openPositions.length > 0 ? (
          openPositions.map((position) => <PositionCard key={position.id} position={position} />)
        ) : (
          <p style={{ color: "#718096", fontStyle: "italic" }}>No open positions</p>
        )}
      </div>

      {/* Closed Positions */}
      <div>
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            color: "#2d3748",
            marginBottom: "20px",
          }}
        >
          Closed Nominations
        </h2>
        {closedPositions.length > 0 ? (
          closedPositions.map((position) => <PositionCard key={position.id} position={position} />)
        ) : (
          <p style={{ color: "#718096", fontStyle: "italic" }}>No closed positions</p>
        )}
      </div>
    </div>
  );
}

